import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { Papel, StatusEtapa, StatusOS, TipoEtapa } from '@/lib/etapas-labels';

export interface MeuPainelOsAtiva {
  id: string;
  codigo: string;
  nomeProjeto: string;
  status: StatusOS;
  cliente: { id: string; nome: string };
  etapaAtualDoUsuario: {
    id: string;
    tipo: TipoEtapa;
    numero: number;
    status: StatusEtapa;
    papelResponsavel: Papel;
  } | null;
}

export interface TarefaPendente {
  id: string;
  tipo: string;
  descricao: string;
  criadaEm: string;
  os: { id: string; codigo: string; nomeProjeto: string } | null;
  papelAlvo: Papel | null;
}

export interface ItemAguardandoDetalhamento {
  osId: string;
  codigo: string;
  totalItens: number;
}

/** Sprint 16 — payload completo do Meu Painel. */
export interface DiaMinhaSemana {
  dia: string; // YYYY-MM-DD
  horas: number;
  distribuicao: {
    DESENVOLVIMENTO_NORMAL: number;
    AJUSTE_REVISAO_PRODUTO: number;
    CORRECAO_CLIENTE: number;
  };
}

export interface ConcluidaRecentemente {
  osId: string;
  codigo: string;
  tipoEtapa: string;
  concluidaEm: string;
}

export interface MeuPainelPayload {
  minhas_os_ativas: MeuPainelOsAtiva[];
  tarefas_pendentes: TarefaPendente[];
  /**
   * Sprint 14 — só populado para usuários com papel AUXILIAR_PROJETOS.
   * Agregado POR OS de itens liberados não-detalhados. Vazio para demais
   * papéis (Gestor / 3D / Detalhista) — UI esconde a seção.
   */
  itens_aguardando_detalhamento: ItemAguardandoDetalhamento[];
  /** Sprint 16 — últimas 5 etapas concluídas pelo usuário. */
  concluidas_recentemente: ConcluidaRecentemente[];
  horas_hoje: number;
  /** Sprint 16 — 7 entradas: 6 dias anteriores + hoje. */
  minha_semana: DiaMinhaSemana[];
}

export const meuPainelKeys = {
  all: ['me', 'painel'] as const,
};

export function useMeuPainel() {
  return useQuery({
    queryKey: meuPainelKeys.all,
    queryFn: async () => {
      const { data } = await api.get<MeuPainelPayload>('/me/painel');
      return data;
    },
  });
}
